import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../api/marvarApi"
import { parseNumber } from "helpers";
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

import jsPDF from "jspdf";
import 'jspdf-autotable';
import { justifyText, justifyTextBox } from "common";

export const useFetchInitLawyerPayments = ({location, paramsURL}) => {
    
    const dispatch = useDispatch()

    const pdfLandscapeDoc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'letter',
    });
    const pdfPortraitDoc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'letter',
    });
    const pdfManager = {
        pdfLandscapeDoc,
        pdfPortraitDoc,
        justifyText,
        justifyTextBox
    }

    const { user } = useSelector((state) => state.auth)

    // const { pathname } = location
    // const { COD_SOLICITUD_USUARIO } = paramsURL
    // const urlWithoutParam = pathname.split('/')[2]; // extrae solo la url (modificar-solicitud)
    // console.log('useFetchInitFormCargoServices')
    // console.log(paramsURL)
    // console.log(pathname) // TRAE ESTO: "/servicios-a-la-carga/modificar-solicitud/b9063205b678858c"
    // console.log(COD_SOLICITUD_USUARIO) // TRAE ESTO: "b9063205b678858c"
    // console.log(urlWithoutParam) // TRAE ESTO: "b9063205b678858c"

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // Helpers ------------------------------------------------------------------------------------
    const Helpers = useHelpers({parseNumber})
    
    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({Helpers})
    
    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }
    // Para la modal -------------------------------------------------------

    // useForm ------------------------------------------------------------------------------------
    const FormScreen = useForm(defaultData.defaultFormScreen)
    const Forms = {
        FormScreen
    }
    
    // FetchData ----------------------------------------------------------------------------------
    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, pdfManager, parseNumber,
        //------------- globalStates
        globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms 
    }

    const fetchAllPayments = useFetchData.useFetchAllPayments({...defaultFetchParams})
    const fetchSpecificPayment = useFetchData.useFetchSpecificPayment({...defaultFetchParams})
    const fetchInfoProcessLawyer = useFetchData.useFetchInfoProcessLawyer({...defaultFetchParams})
    const fetchAllCashRegisters = useFetchData.useFetchAllCashRegisters({...defaultFetchParams})
    const fetchAllBanks = useFetchData.useFetchAllBanks({...defaultFetchParams})

    const FetchData = {
        fetchAllPayments,
        fetchSpecificPayment,
        fetchInfoProcessLawyer,
        fetchAllCashRegisters,
        fetchAllBanks
    }

    // Actions ------------------------------------------------------------------------------------
    const Actions = useActions({
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, toggle, pdfManager, parseNumber,
        //------------- globalStates
        globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms,
        //------------- FetchData
        FetchData
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, location, paramsURL,
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    })
}